import styled from '@emotion/styled'

const RefillRoot = styled.div({
	display: 'flex',
	flexDirection: 'column',
	gap: '.5rem',
	justifyContent: 'center',
	padding: '1.5rem 1rem',
})

const RefillTitle = styled.div(({theme}) => ({
	...theme.fonts.bodyBold,
	color: theme.colors.inputLabel,
	textAlign: 'center',
}))

const RefillSubtitle = styled.div(({theme}) => ({
	color: theme.colors.inputLabel,
	textAlign: 'center',
}))

interface V2L1DashboardListEmptyPlaceholderProps {
	title: string
	subtitle?: string
}

export const V2L1DashboardListEmptyPlaceholder = ({title, subtitle}: V2L1DashboardListEmptyPlaceholderProps) => {
	return (
		<RefillRoot>
			<RefillTitle>{title}</RefillTitle>
			{subtitle ? <RefillSubtitle>{subtitle}</RefillSubtitle> : null}
		</RefillRoot>
	)
}
